import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import { useDispatch, useSelector } from "react-redux"
import Icon from "../../common/icon/icon.component"
import AddPricingRow from "../../common/pricing/addItem.component"
import PricingTableTotals from "../../common/pricing/totals.component"
import { AddFromOrderModal } from "../../inventory/modals/AddFromOrderModal"
import IntlProps from "../../state/helpers/IntlProps"
import { StockDocumentAction } from "../../state/inventory/stockdocument/actions"
import { StockDocumentSelector } from "../../state/inventory/stockdocument/selectors"
import { createGroup } from "../../state/pricing/actions"
import { INVENTORY_STOCK_DIRECTION } from "../../utils/inventory"
import { PRICING_TABLES } from "../../utils/pricing/constants"
import { PRICING_TABLE_MESSAGES } from "../../utils/pricing/messages"
import PricingTableContent from "../PricingTableContentComponent"
import "../styles/main.scss"

export const StockDocumentPricingTable = injectIntl((props: IntlProps) => {
    const doc = useSelector(StockDocumentSelector.get)
    const dispatch = useDispatch()
    const isDraft = useSelector(StockDocumentSelector.isDraft)
    const [modal, setModal] = React.useState(<></>)

    const openModal = (itemId?: string, productId?: string) => {
        setModal(<AddPricingRow
            mainObject={PRICING_TABLES}
            mainObjectItem={PRICING_TABLES}
            objectId={doc.table.id}
            objectIdentifier={doc.identifier}
            onClose={() => setModal(<></>)}
            itemId={itemId}
            productId={productId}
            currency={AppContext.getAccount().currency}
            exchangeRate={"0"}
            onItemAdd={() => {
                setModal(<></>)
                dispatch(StockDocumentAction.fetch(doc.id))
            }}
            stockDocument={doc}
        />)
    }
    const openAddFromOrderModal = () => {
        setModal(
            <AddFromOrderModal
                supplierId={doc.project.attributes.contactId}
                mainLocationIds={doc.inventoryLocation.attributes.locationIds}
                onCloseCallback={() => setModal(<></>)}
            />
        )
    }

    const addGroup = () => {
        dispatch(createGroup({
            name: props.intl.formatMessage(PRICING_TABLE_MESSAGES["default_group_name"]),
            rank: doc.table.attributes.groups.length
        }))
    }

    return (
        <div className="row mb-5">
            <div className="col-12">
                {modal}
                <div className="row px-3">
                    <div className="col-12 d-flex justify-content-between">
                        <h4 className={"custom-lead"}>
                            <FormattedMessage
                                id="pricing.sections.stock_document_pricing_table.title"
                                defaultMessage="Pricing table"/>
                        </h4>
                    </div>
                </div>

                <div className="m-0 px-3">
                    <div className={"ui-module pt-0"}>
                        <PricingTableContent
                            tableId={doc.table.id}
                            objectId={doc.table.id}
                            stockDocument={doc}
                            mainObject={PRICING_TABLES}
                            onUpdate={() => dispatch(StockDocumentAction.fetch(doc.id))}
                            currency={doc.table.attributes.currency}
                            allowEdit={isDraft}
                            sortable={isDraft}
                            showInventoryDetails={true}
                            onEditLinkClick={openModal}
                        />
                        {isDraft &&
                        <div className={"d-flex flex-wrap"}>
                            <div className={"p-1 flex-fill"}>
                                <div className="pt-2 quote-add-product flex-fill" onClick={() => openModal()}>
                                    <a href="#" className="btn btn-link btn-add-product">
                                        <FormattedMessage
                                            id="pricing.sections.stock_document_pricing_table.add_btn"
                                            defaultMessage="Add a product"/>
                                    </a>
                                </div>
                            </div>

                            {doc.definition.attributes.direction === INVENTORY_STOCK_DIRECTION.IN &&
                                <div className={"p-1 flex-fill"}>
                                    <div className="pt-2 add-from-order" onClick={() => openAddFromOrderModal()}>
                                        <a href="#" className="btn btn-link text-custom-secondary">
                                            <FormattedMessage
                                                id="pricing.sections.stock_document_pricing_table.add_from_open_orders_btn"
                                                defaultMessage="Add from open orders"/>
                                        </a>
                                    </div>
                                </div>
                            }
                        </div>
                        }

                        <div className={"row mb-3"}>
                            <div className={"col-md-4"}>
                                <div className={"mt-4 pt-2 mb-0 w-100"}>
                                    {isDraft && 
                                        <button className={"btn btn-outline-primary"} onClick={addGroup}>
                                            <Icon value={"layer-group"} className={"mr-1"}/>
                                            <FormattedMessage
                                                id="pricing.sections.stock_document_pricing_table.add_btn.add_group_btn"
                                                defaultMessage="Add a group"/>
                                        </button>
                                    }
                                </div>
                            </div>

                            <div className={"col-md-8 pb-3"}>
                                <PricingTableTotals
                                    totalClassName={"col-lg-8 col-md-12"}
                                    allowEdit={true}
                                    mainObjectId={doc.table.id}
                                    mainObject={PRICING_TABLES}
                                    stockDocument={doc}
                                    onChange={() => dispatch(StockDocumentAction.fetch(doc.id))}
                                    rows={doc.table.attributes.items}
                                    pricingTableId={doc.table.id}
                                    stockDocumentId={doc.id}
                                    contactId={doc.contactId}
                                    hideDeposit={true}
                                    hideMargin={true}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
})


// WEBPACK FOOTER //
// ./src/pricing/sections/StockDocumentPricingTable.tsx